export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER_ID: 'userId',
  USER_INFO: 'user_information',
};
